module.exports = __webpack_public_path__ + "img/scene4copy03.5a099310.png";